import { ComponentProps } from 'react'

import { cn } from '@/utils/tailwind'

export const BackgroundPattern = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={cn('bg-background-pattern bg-size-[375px_auto] bg-repeat', className)} {...props} />
)
